import { render, staticRenderFns } from "./list-pendencies.vue?vue&type=template&id=2234df62&scoped=true&"
import script from "./list-pendencies.vue?vue&type=script&lang=js&"
export * from "./list-pendencies.vue?vue&type=script&lang=js&"
import style0 from "./list-pendencies.vue?vue&type=style&index=0&id=2234df62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234df62",
  null
  
)

export default component.exports